import {SET_DESTINATION_IMAGES} from '../../actions/action-types';
import {TEMPLATE_ID_HEADER, BOT_HEADER} from '../../utils/constants';

// actions
export function setDestinationImages(payload) {
    return {
        type: SET_DESTINATION_IMAGES,
        payload,
    };
}

export function fetchImages({basePathPrefix, lbsIds = []}) {
    return (dispatch, getState) => {
        const {
            config: {
                template,
                context: {isBot},
            },
        } = getState();
        const pathName = `${basePathPrefix}/api/images?ids=${lbsIds.join(
            '&ids='
        )}`;

        return fetch(pathName, {
            credentials: 'same-origin',
            headers: {
                [TEMPLATE_ID_HEADER]: template,
                [BOT_HEADER]: isBot,
            },
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed loading destination images');
                }
                return res.json();
            })
            .then((res) => {
                if (Array.isArray(res)) {
                    dispatch(setDestinationImages(res));
                }
            })
            .catch((err) => console.log(err)); // eslint-disable-line no-console
    };
}

// reducers - check destination reducer for destination images
